<template>
  <div class="auth-wrapper-provider">
    <Login
      v-if="state === 'LOGIN'"
      @setUsername="setUsername"
      @setPassword="setPassword"
      @setMobile="setMobile"
      @setExpireSeconds="setExpireSeconds"
    />
    <VerifyCode v-if="state === 'VERIFY_CODE'" />
  </div>
</template>

<script>
import Login from "./components/Login.vue";
import VerifyCode from "./components/VerifyCode.vue";
import { computed, provide, ref } from "vue";
import { pathOr } from "ramda";
import { generateError, goToRoute, toastAlert } from "@/shared/utils";
import { twoStep } from "@/modules/auth/services";

export default {
  components: { Login, VerifyCode },

  methods: {
    pathOr,
    goToRoute,
  },
  setup() {
    const state = ref("LOGIN");
    const setState = (val) => (state.value = val);
    const goToLogin = () => setState("LOGIN");
    const goToVerifyCode = () => setState("VERIFY_CODE");

    const username = ref(null);
    const setUsername = (uName) => (username.value = uName);
    const password = ref(null);
    const setPassword = (pass) => (password.value = pass);
    const mobile = ref(null);
    const setMobile = (mNumber) => (mobile.value = mNumber);
    const expireSeconds = ref(null);
    const setExpireSeconds = (exAt) => (expireSeconds.value = exAt);

    const goToContactUs = () => goToRoute("contact-us", {}, {}, false);
    const submitVerifyCode = async (code) => {
      try {
        const response = await twoStep(username.value, password.value, code);
        const { routeName, message } = response;

        // successfully login
        toastAlert(message);
        goToRoute(routeName, {}, {}, false);
      } catch (error) {
        generateError(error);
      }
    };

    // generate provide data to child components
    provide(
      "USERNAME",
      computed(() => username.value)
    );
    provide(
      "MOBILE",
      computed(() => mobile.value)
    );
    provide(
      "EXPIRE_SECONDS",
      computed(() => expireSeconds.value)
    );
    provide("setState", setState);
    provide("goBack", goToLogin);
    provide("goToVerifyCode", goToVerifyCode);
    provide("goToContactUs", goToContactUs);
    provide("submitVerifyCode", submitVerifyCode);

    // return data to be used in template
    return { state, setUsername, setPassword, setMobile, setExpireSeconds };
  },
};
</script>
